import HousingService from '../../services/portefeuille/HousingService'
import PortefeuilleService from '../../services/portefeuille/PortefeuilleService'

const Housings = {
    namespaced: true,
    state: {
        listeHousings: [],
        count: 0,
        errors: {},
        loading: false
    },
    getters: {
        listeHousings: state => state.listeHousings,
        count: state => state.count,
        loading: state => state.loading
    },
    mutations: {
        setLoadingState(state, loading) {
            state.loading = loading
        },
        setHousings(state, housings) {
            state.listeHousings = Array.isArray(housings) ? housings : []
            state.count = state.listeHousings.length
            state.errors = {}
        },
        addHousingCommit(state, housing) {
            state.listeHousings.push(housing)
            state.count = state.listeHousings.length
        },
        updateHousingCommit(state, updatedHousing) {
            const index = state.listeHousings.findIndex(h => h._id === updatedHousing._id)
            if (index !== -1) {
                state.listeHousings.splice(index, 1, updatedHousing)
            }
        },
        removeHousingCommit(state, housingId) {
            state.listeHousings = state.listeHousings.filter(h => h._id !== housingId)
            state.count = state.listeHousings.length
        },
        setErrors(state, error) {
            state.errors = error
        }
    },
    actions: {
        async fetchHousings({commit}) {
            commit('setLoadingState', true)
            try {
                const response = await PortefeuilleService.getPortefeuille()
                const housings = (response.data.portefeuille && response.data.portefeuille.logements) || []
                commit('setHousings', housings)
                return housings
            } catch (error) {
                console.error('Erreur chargement logements:', error)
                commit('setErrors', error)
                throw error
            } finally {
                commit('setLoadingState', false)
            }
        },
        async addHousing({commit, dispatch}, housingData) {
            try {
                await HousingService.createHousing(housingData)
                const housings = await dispatch('fetchHousings')

                return housings[0] || null
            } catch (error) {
                console.error('Erreur ajout logement:', error)
                commit('setErrors', error)
                throw error
            }
        },
        async updateHousing({commit, dispatch}, {id, housingData}) {
            try {
                await HousingService.updateHousing(id, housingData)
                const housings = await dispatch('fetchHousings')

                return housings.find(housing => housing._id === id) || null
            } catch (error) {
                console.error('Erreur modification logement:', error)
                commit('setErrors', error)
                throw error
            }
        },
        async deleteHousing({commit}, housingId) {
            try {
                const response = await HousingService.deleteHousing(housingId)
                const deletionResult = response && response.data

                if (!deletionResult || deletionResult.message !== 'Habitation deleted') {
                    throw new Error('Housing deletion was not acknowledged by the API')
                }

                commit('removeHousingCommit', housingId)
            } catch (error) {
                console.error('Erreur suppression logement:', error)
                commit('setErrors', error)
                throw error
            }
        }
    }
}

export default Housings
